import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { PaginatedResultModel } from '@data-layer/models/common';
import { FavoriteHtsNumberModel } from '@data-layer/models/common/favorite-hts-number.model';
import { BinaRepository } from '@data-layer/repositories';
import { HtsAssistantHelper } from '../helpers/hts-assistant.helper';

/**
 * Silent, stateless lookup behind the assistant drawer: the company's catalog codes. Every failure is an empty result —
 * nothing here may block the chat.
 */
@Injectable({ providedIn: 'root' })
export class HtsCodeLookupService {
  constructor(private binaRepository: BinaRepository) {}

  /** Digits of every active code in the company's Bina Catalog. */
  public getActiveCatalogDigits(companyId: number): Observable<string[]> {
    return this.binaRepository.searchFavoriteHtsNumbers({ companyId }, false).pipe(
      map((result: PaginatedResultModel<FavoriteHtsNumberModel>) =>
        ((result && result.items) || [])
          .filter((item: FavoriteHtsNumberModel) => item.isActive)
          .map((item: FavoriteHtsNumberModel) => HtsAssistantHelper.toDigits(item.htsNumber))
          .filter((code: string) => !!code),
      ),
      catchError(() => of([] as string[])),
    );
  }
}
